import { render, staticRenderFns } from "./FilterModule.vue?vue&type=template&id=45548b2a&"
import script from "./FilterModule.vue?vue&type=script&lang=js&"
export * from "./FilterModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports